// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1AgR5","container":"styles_container__3RjqR","title":"styles_title__15gW_","wrapper":"styles_wrapper__2_Fzp","answer":"styles_answer__2GUQB"};